module.exports = __webpack_public_path__ + "img/DE01030.f8b5dfe8.png";